module.exports = __webpack_public_path__ + "img/dcfc62ec1936e9d630e7a4d1919390a.25ee900f.png";